export enum ProgramFormat {
	HYBRID = 'online_and_in_person',
	IN_PERSON = 'in_person',
	ONLINE = 'Online Program',
	ONLINE_OR_IN_PERSON = 'online_or_in_person',
}
